import React, { useState } from "react";
export default function Select({ options, name, onChange }) {
  options.sort((a, b) => a.label < b.label);

  // State with list of all checked item
  const [checked, setChecked] = useState([]);

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
    onChange(updatedList);
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ maxHeight: 300, overflow: "auto", paddingBottom: 50 }}>
        {options.map(({ value, label }) => {
          const slug = slugify(label);

          return (
            <div
              key={slug + value}
              style={{
                display: "flex",
                alignItems: "start",
                borderBottom: "1px solid #f9f9f9",
                padding: 5,
                fontSize: 12,
              }}
            >
              <input
                type="checkbox"
                id={slug}
                name={name}
                value={label}
                onChange={handleCheck}
              />
              <label style={{ paddingLeft: 5, paddingTop: 2 }} htmlFor={slug}>
                {label}
              </label>
            </div>
          );
        })}
      </div>
      <div
        style={{
          width: "100%",
          height: "50px",
          position: "absolute",
          bottom: "0",
          left: "0",
          zIndex: "2",
          pointerEvents: "none",
          background:
            "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
        }}
      ></div>
    </div>
  );
}

const slugify = (str) =>
  str
    ?.toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "") || null;
